import { css } from 'styled-components';

export const resetCss = css`
	* {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
	}

	::-webkit-scrollbar-track {
		background-color: transparent;
	}

	::-webkit-scrollbar-thumb {
		background-color: var(--greenUltraLight);
		border-radius: 1.25rem;
		border: 0.375rem solid transparent;
		background-clip: content-box;
	}

	img {
		display: block;
	}
`;
